export default "__VITE_ASSET__DQyqA_je__"